module.exports = __webpack_public_path__ + "static/media/M1-13-Grimório-Arcano-cod112.a1a36c3a.png";